import { render, staticRenderFns } from "./GasLabel.vue?vue&type=template&id=719707a4&"
import script from "./GasLabel.vue?vue&type=script&lang=js&"
export * from "./GasLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports